import React, { lazy, Suspense } from "react";
import { Route, Routes as ReactRoutes } from "react-router-dom";
import Layout from "./components/Layout";
import LoadingPage from "./components/LoadingPage";
import { useOutlook } from "./hooks/useOutlook";
import SearchPayables from "./pages/Payables/SearchPayables/SearchPayables";

const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const Profile = lazy(() => import("./pages/Profile/Profile"));
const Settings = lazy(() => import("./pages/Settings/Settings"));
const Chasables = lazy(() => import("./pages/Chasables/Chasables"));
const SuggestedChasable = lazy(() => import("./pages/Chasables/SuggestedChasable/SuggestedChasable"));
const SearchChasables = lazy(() => import("./pages/Chasables/SearchChasables/SearchChasables"));
const Activities = lazy(() => import("./pages/Activities/Activities"));
const Contacts = lazy(() => import("./pages/Payables/Contacts"));
const Payables = lazy(() => import("./pages/Payables/Payables"));
const PayableInvoiceDetail = lazy(() => import("./pages/Payables/PayableInvoiceDetail"));
const Receivables = lazy(() => import("./pages/Payables/Receivables"));
const ReceivableInvoiceDetail = lazy(() => import("./pages/Payables/ReceivableInvoiceDetail"));
const QuickAddInvoice = lazy(() => import("./pages/Invoices/QuickAddInvoice/QuickAddInvoice"));

export function Routes() {
  const { isInReadMode } = useOutlook();
  const readModeOnlyRoutes = (
    <>
      <Route path="contacts" element={<Contacts />} />
      <Route path="receivables/:customerId" element={<Receivables />} />
      <Route path="payables/:supplierId/quick-add/:invoiceFileName/job/:jobId" element={<QuickAddInvoice />} />
    </>
  );

  return (
    <Suspense fallback={<LoadingPage />}>
      <ReactRoutes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="chasables" element={<Chasables />} />
          <Route path="chasables/suggested/:id" element={<SuggestedChasable />} />
          <Route path="chasables/suggested" element={<SuggestedChasable />} />
          <Route path="chasables/search" element={<SearchChasables />} />
          <Route path="payables/search" element={<SearchPayables />} />
          <Route path="payables/:supplierId" element={<Payables />} />
          <Route path="payables/:supplierId/:invoiceId" element={<PayableInvoiceDetail />} />
          <Route path="activities/:emailId?" element={<Activities />} />
          {isInReadMode && readModeOnlyRoutes}
          <Route path="receivables/:customerId/:invoiceId" element={<ReceivableInvoiceDetail />} />
          <Route path="*" element={<Dashboard />} />
        </Route>
      </ReactRoutes>
    </Suspense>
  );
}
